import React from "react";
import styles from "./MenuList.module.css";
// components
import { AppBar, MenuLogo, MenuIconItem } from "../index";

//material ui
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MenuTabs from "../MenuTabs/MenuTabs";
import MenuTop from "../MenuTop/MenuTop";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    boxShadow: "none",
  },
}));

const MenuList = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container className={styles.menu_top}>
        <Grid item xs={12} sm={12}>
          <MenuTop />
        </Grid>
      </Grid>
      <Grid container spacing={0}>
        <Grid item xs={4} sm={2}>
          <Paper className={classes.paper} style={{ padding: 0 }}>
            <MenuLogo />
          </Paper>
        </Grid>
        <Grid item xs={4} sm={8}>
          <span className={styles.menu_texts}>
            <MenuTabs variant="fullWidth" orientation="horizontal" />
          </span>

          <span className={styles.menu_app_bar}>
            <AppBar />
          </span>
        </Grid>
        <Grid item xs={4} sm={2}>
          <Paper className={classes.paper} style={{ padding: 0 }}>
            <MenuIconItem />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default MenuList;
